import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./style";
import TooltipOffers from "../../../../../shared/create-offer/TooltipOffers/TooltipOffers";
import { useNewOffer } from "../../../../context/new-offer";
import { floatFormat, formatCurrency } from "../../../../../shared/create-offer/utils/formats";

const StepExpectedGainEdit = () => {
    const { offerData } = useNewOffer();
    const { price, quant } = offerData.data;
    const totalExpectedGain = (parseInt(quant) / 1000) * floatFormat(price.toString()) || 0;

    return (
        <div
            className={css`
                ${defaultStyle}
            `}
        >
            <div className="expected--tooltip">
                Receba até
                <TooltipOffers
                    position="bottom-start"
                    content={
                        <p style={{ fontWeight: "bold", textAlign: "left" }}>
                            Valor total a receber caso venda todas as milhas.
                        </p>
                    }
                />
            </div>
            <p className="expected--price">
                R$ <strong>{formatCurrency(totalExpectedGain)}</strong>
            </p>
        </div>
    );
};

export default StepExpectedGainEdit;